import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MyBrokerFirm from './MyBrokerFirm';
import { routesSiderRight } from '../../utils/constants/routes';
import MyBrokerTeam from './MyBrokerTeam/MyBrokerTeam';
import CreateUpdateInsurer from '../insurers/CreateUpdateInsurer';
import Clients from './MyBrokerCustomer/Clients';
import { Dashboard } from './dashboard/Dashboard';
import MyBrokerCommissions from './MyBrokerCommissions/MyBrokerCommissions';
import Settings from './myBrokerParams/Settings';
import CreateUpdateCompliance from './MyBrokerCompliance/CreateUpdateCompliance';
import MyComplaints from './MyComplaints/MyComplaints';
import MyGroup from './MyGroup/MyGroup';
import Profile from '../profile/Profile';

const SettingsRouter = () => {
  return (
    <Routes>
      <Route path="edit/:id" element={<CreateUpdateInsurer purpose="edit" />} />
      <Route
        path={`${routesSiderRight.BROKER_COMPLIANCE}/:id`}
        element={<CreateUpdateCompliance purpose="edit_compliance" />}
      />
      <Route path={routesSiderRight.BROKER_FIRM} element={<MyBrokerFirm />} />
      <Route path={routesSiderRight.BROKER_TEAM} element={<MyBrokerTeam />} />
      <Route path={routesSiderRight.BROKER_CLIENTS} element={<Clients />} />
      <Route path={routesSiderRight.BROKER_DASHBOARD} element={<Dashboard />} />
      <Route
        path={routesSiderRight.BROKER_COMMISSIONS}
        element={<MyBrokerCommissions />}
      />
      <Route path={routesSiderRight.BROKER_SETTINGS} element={<Settings />} />
      <Route path={routesSiderRight.BROKER_CLAIMS} element={<MyComplaints />} />
      <Route path={routesSiderRight.BROKER_GROUP} element={<MyGroup />} />

      <Route path={routesSiderRight.BROKER_PROFILE} element={<Profile />} />
    </Routes>
  );
};

export default SettingsRouter;
